"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var material_rounded_1 = require("@styled-icons/material-rounded");
var layout_types_1 = require("../themes/layout/layout-types");
var props = {
    fill: 'inherit',
};
var iconForName = ({
    "account-balance": material_rounded_1.AccountBalance,
    "add": material_rounded_1.Add,
    "chevron-left": material_rounded_1.ChevronLeft,
    "delete": material_rounded_1.DeleteOutline,
    "edit": material_rounded_1.Edit,
    "error": material_rounded_1.ErrorOutline,
    "euro": material_rounded_1.Euro,
    "help": material_rounded_1.Help,
    "home": material_rounded_1.Home,
    "logout": material_rounded_1.Logout,
    "people": material_rounded_1.People,
    "place": material_rounded_1.Place,
    "show_chart": material_rounded_1.ShowChart,
    "lock": material_rounded_1.Lock,
    "trending-up": material_rounded_1.TrendingUp,
});
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'md' : _b, otherProps = __rest(_a, ["name", "size"]);
    var allProps = __assign(__assign(__assign({}, props), otherProps), { size: layout_types_1.ICON_SIZES[size] });
    var IconComponent = iconForName[name];
    return react_1.default.createElement(IconComponent, __assign({}, allProps));
};
exports.Icon = Icon;
